import { lighten, styled } from '@mui/material';
import Box from '@mui/material/Box';

import { colorLightenFactor } from '../../../styles';

type Props = {
  children: React.ReactNode;
  color: string;
};

const shouldForwardProp = (prop: string) => prop !== 'color';
const BoxStyled = styled(Box, { shouldForwardProp })<{ color: string }>`
  display: flex;
  align-items: center;
  height: 100%;
  max-width: 120px;
  padding: ${({ theme }) => theme.spacing(1)};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  background-color: ${({ color }) => lighten(color, colorLightenFactor)};
`;

const EllipsisWrap = styled(Box)`
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const LabwareCellContent = ({ children, color }: Props): JSX.Element => {
  return (
    <BoxStyled color={color}>
      <EllipsisWrap>{children}</EllipsisWrap>
    </BoxStyled>
  );
};

export default LabwareCellContent;
